import * as d3 from 'd3';
import svgParser from '@/tools/parser';
import svgMolecules from '@/data/molecules';

const graphics = {
        svg : null,
        toggleLayer : null,
        moleculeLayer : null,
        buttons : []
    },
    molecules = [0, 0, 0, 0, 0],
    toggles = [{
        label : ['through anticipated change in', 'social and economic patterns'],
        status : false,
        value : [1, 52, 11, 1, 7]
    }, {
        label : ['through existing air', 'pollution legislation'],
        status : false,
        value : [37, 21, 51, 7, 33]
    }, {
        label : ['through additional measures', 'to control air pollution'],
        status : false,
        value : [25, 7, 3, 17, 6]
    }];

// drag = d3.behavior.drag().on('dragstart', function() {
// }).on('drag', function() {
//     x = d3.event.x;
//     d3.select(this).attr('cx', limitX(x));
// }).on('dragend', function() {
//     d3.select(this).attr('cx', positionX(x, this));
// });

function buildCanvas(element) {
    graphics.svg = d3.select(element).append('svg').attr('width', '100%').attr('height', '100%');
    graphics.toggleLayer = graphics.svg.append('g').attr('class', 'action-layer-toggle');
    graphics.moleculeLayer = graphics.svg.append('g').attr('class', 'action-layer-molecule').attr('transform', function() {
        return 'translate(0,140)';
    });
}

function buildMolecules() {
    for (var i = 0, l = molecules.length; i < l; i++) {
        var g = graphics.moleculeLayer.append('g').attr('class', 'action-group').attr('transform', function(){
                return 'translate(' + (i * 164) + ', 0)';
            }),
            sub;
        g.append('circle').attr('r', 80).attr('cx', 80).attr('cy', 100).attr('class', 'action-static-circle action-static-circle-' + i);
        g.append('circle').attr('r', 80).attr('cx', 80).attr('cy', 100).attr('class', 'action-circle ml-color-' + i + ' action-circle-' + i);
        g.append('text').attr('x', 100).attr('y', 160).text('').attr('class', 'action-circle-perct action-circle-perct-' + i).attr('i', i);
        sub = g.append('g').attr('transform', function(){
            return 'translate(22, 65)';
        });
        console.log(sub);
        svgParser.addIllustration(svgMolecules[i], sub);
    }
}

function buildToggles() {
    for (var i = 0, l = toggles.length; i < l; i++) {
        var g = graphics.toggleLayer.append('g').attr('class', 'action-toggle').attr('transform', function(){
            return 'translate(0,' + (i * 44) + ')';
        });
        g.append('path').attr('d', 'M54.429,14c0,7.7-6.355,14-14.124,14H14.124C6.356,28,0,21.7,0,14C0,6.3,6.356,0,14.124,0h26.182C48.074,0,54.429,6.3,54.429,14').attr('class', 'action-toggle-container');
        g.append('circle').attr('r', 11).attr('cx', 14).attr('cy', 14).attr('toggle', i).attr('class', 'action-toggle-button-hidden').on('click', function () {
            setToggle(false, d3.select(this).attr('toggle'));
        });
        g.append('circle').attr('r', 11).attr('cx', 40).attr('cy', 14).attr('toggle', i).attr('class', 'action-toggle-button-hidden').on('click', function () {
            setToggle(true, d3.select(this).attr('toggle'));
        });
        graphics.buttons[i] = g.append('circle').attr('r', 11).attr('cx', 14).attr('cy', 14).attr('class', 'action-toggle-button action-toggle-button-' + i).attr('toggle', i).on('click', function () {
            toggleToggle(d3.select(this).attr('toggle'));
        });
        g.append('text').attr('x', 70).attr('y', 12).text(toggles[i].label[0]).attr('class', 'action-toggle-label');
        g.append('text').attr('x', 70).attr('y', 27).text(toggles[i].label[1]).attr('class', 'action-toggle-label');
    }
}

function setToggle(status, i) {
    var x;
    toggles[i].status = status;
    if (status) {
        x = 40;
        graphics.buttons[i].attr('class', 'action-toggle-button action-toggle-button-active');
    } else {
        x = 14;
        graphics.buttons[i].attr('class', 'action-toggle-button');
    }

    graphics.buttons[i].attr('cx', x);
    redrawCircles();
}

function toggleToggle(i) {
    var x;
    toggles[i].status = !toggles[i].status;
    if (toggles[i].status) {
        x = 40;
        graphics.buttons[i].attr('class', 'action-toggle-button action-toggle-button-active');
    } else {
        x = 14;
        graphics.buttons[i].attr('class', 'action-toggle-button');
    }

    graphics.buttons[i].attr('cx', x);
    redrawCircles();
}

function redrawCircles() {
    for (var i = 0, l = molecules.length; i < l; i++) {
        var red = getReduction(i);
        d3.select('.action-circle-perct-' + i).text(-red + '%');
        d3.select('.action-circle-' + i).transition().duration(500).attr('r',function() {
            return reductionToRadius(red);
        });
    }
}

function reductionToRadius(red) {
    var fullSurface = 80 * 80 * Math.PI
        , newSurface = ((100 - red) / 100) * (fullSurface);
    return Math.sqrt(newSurface / Math.PI);
}

function getReduction(i) {
    var reduction = 0;
    for (var j = 0, l = toggles.length; j < l; j++) {
        if(toggles[j].status) {
            reduction += toggles[j].value[i];
        }
    }
    return reduction;
}

// function limitX(x) {
//     var limitLeft = 14,
//         limitRight = 40;
//     if (x < limitLeft) {
//         x = limitLeft;
//     } else if (x > limitRight) {
//         x = limitRight;
//     }
//     return x;
// }
//
// function positionX(x, element) {
//     var toggle = $(element).attr('toggle');
//     if (x < 27) {
//         if(toggles[toggle].status) {
//             d3.select(element).attr('class', 'action-toggle-button');
//             toggles[toggle].status = false;
//             redrawCircles();
//         }
//         return 14;
//     } else {
//         if(!toggles[toggle].status) {
//             d3.select(element).attr('class', 'action-toggle-button action-toggle-button-active');
//             toggles[toggle].status = true;
//         }
//         redrawCircles();
//         return 40;
//     }
// }

export const render = (element) => {
    buildCanvas(element);
    buildMolecules();
    buildToggles();
};
